
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electronic-transfers-agreement",
      function () {
        return require("private-next-pages/electronic-transfers-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electronic-transfers-agreement"])
      });
    }
  